import { EVENT_SOURCE } from '../../constants/analytics';
import type { FireAnalyticsEvent } from '../../types';

type CacheRequestName = 'search-config' | `search-3p-config`;

type onCacheAccessArgs = {
	requestName: CacheRequestName;
	searchSessionId: string;
	cacheHit: boolean;
	refreshTriggered: boolean;
};

// Record the hit/miss rate of request caching
export const onRequestCacheAccess = ({
	requestName,
	searchSessionId,
	cacheHit,
	refreshTriggered,
}: onCacheAccessArgs): FireAnalyticsEvent => {
	return {
		source: EVENT_SOURCE,
		action: 'requestCacheAccess',
		actionSubject: 'searchPage',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				requestName,
				cacheHit,
				refreshTriggered,
				searchSessionId,
			},
		},
	};
};
